import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { PageLoaderService } from '@hub/services/PageLoader';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '@hub/services/NotificationService';
import { eFrequencyType, eColumnType, eSortDir, eCurrency} from '@hub/generated/enums';
import { Functions } from '@hub/common/Functions';
import { SubGridItem } from '@hub/models/common/ui/SubGridItem';
import { Table } from 'primeng/table';
import { PaymentGeneratorPaymentsModel } from '@hub/models/paymentGeneratorPayments.model';
import { PaymentGeneratorModel } from '@hub/models/paymentGenerator.model';

@Component({
  selector: 'payment-generate-dialog',
  templateUrl: './payment-generate-dialog.component.html'
})
export class PaymentGenerateDialogComponent
  implements OnInit, OnDestroy {

  constructor(
    public notificationService: NotificationService,
    public pageLoaderService: PageLoaderService,
    public confirmationService: ConfirmationService,
  ) { }

  isSaveDisable: boolean = false;
  isBackClick: boolean = false;
  currencyName: string;
  totalGrossAmount: number = 0;
  totalNetAmount: number = 0;
  dropDownClicked: boolean = false;
  errorList: string[] = [];

  @Input() paymentData: PaymentGeneratorModel = null;
  visible: boolean = false;

  paymentGenerateData: PaymentGeneratorPaymentsModel[] = [];
  dateAddonValue: number = 0;
  monthAddonValue: number = 0;
  public type = eColumnType;

  @ViewChild(Table) paymentTable: Table;
  @Output() onClose = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Output() onBack = new EventEmitter();

  @Output() displayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  get display(): boolean {
    return this.visible;
  }

  set display(val) {
    this.visible = val;
    this.displayChange.emit(val);
  }

  public get columns(): SubGridItem[] {
    let result = [
      { Field: 'DueDate', Header: 'Due Date', ColumnType: eColumnType.Date },
      { Field: 'Commission', Header: 'Commission', ColumnType: eColumnType.PlainText, Sorting: eSortDir.NotSet, TextAlign: "text-right" },
      { Field: 'GrossAmount', Header: 'GrossAmount', ColumnType: eColumnType.PlainText, TextAlign: "text-right" },
      { Field: 'NetAmount', Header: 'NetAmount', ColumnType: eColumnType.PlainText, TextAlign: "text-right" }
    ];

    return result;
  }

  ngOnInit() {
    this.currencyName = Functions.getEnumName(eCurrency, this.paymentData.CurrencyTypeId);
    this.setMonthAddonValue();
    this.setTableData();
  }

  private setMonthAddonValue() {
    if (this.paymentData.FrequencyTypeId == eFrequencyType.Monthly) {
      this.monthAddonValue = 1;
    } else if (this.paymentData.FrequencyTypeId == eFrequencyType.Bi_Monthly) {
      this.monthAddonValue = 2;
    } else if (this.paymentData.FrequencyTypeId == eFrequencyType.Quarterly) {
      this.monthAddonValue = 3;
    } else if (this.paymentData.FrequencyTypeId == eFrequencyType.Semi_Anually) {
      this.monthAddonValue = 6;
    } else if (this.paymentData.FrequencyTypeId == eFrequencyType.Anually) {
      this.monthAddonValue = 12;
    } else if (this.paymentData.FrequencyTypeId == eFrequencyType.Weekly) {
      this.dateAddonValue = 7;
    } else if (this.paymentData.FrequencyTypeId == eFrequencyType.Bi_Weekly) {
      this.dateAddonValue = 14;
    }
  }

  ngOnDestroy() {
  }

  onCloseModal() {
    if (!this.isBackClick) {
      this.onClose.emit();
    }
  }

  showList(): string {
    let temp: string = ``;
    for (let error of this.errorList) {
      temp += `<span>${error}</span><br>`;
    }
    return temp;
  }

  onBlur() {
    this.paymentTable.editingCell = null;
  }

  isNumber(event) {
    var keycode = event.keyCode;
    if (keycode >= 48 && keycode < 57) {
      return true;
    }
    return false;
  }

  setTableData() {
    if (this.paymentData.PaymentsData) {
      for (var i = 0; i < this.paymentData.PaymentCount; i++) {
        var newDate = new Date(this.paymentData.StartDate);

        var generateData: PaymentGeneratorPaymentsModel = {
          Commission: this.paymentData.Commission,
          DueDate: this.checkDate(newDate, (this.monthAddonValue != 0 ? this.monthAddonValue : this.dateAddonValue) * i),
          GrossAmount: this.paymentData.TotalPaymentAmount / this.paymentData.PaymentCount,
          NetAmount: (this.paymentData.TotalPaymentAmount / this.paymentData.PaymentCount) * (this.paymentData.Commission / 100),
        }

        this.paymentGenerateData.push(generateData);
      }
    } else {
      this.paymentGenerateData = this.paymentData.PaymentsData;
    }

    this.setTotalValues();
  }

  private setTotalValues(): void {
    var totalGross = 0;
    var totalNet = 0;
    this.paymentGenerateData.forEach((i) => {
      totalGross += i.GrossAmount;
      totalNet += i.NetAmount;
    });
    this.totalGrossAmount = totalGross;
    this.totalNetAmount = totalNet;
  }

  onBackClick() {
    this.isBackClick = true;
    this.onBack.emit();
  }

  onChange(data, isDate, isBlur = false) {
    if (!isDate) {
      this.paymentGenerateData.filter(x => x == data)[0].NetAmount = data.GrossAmount * data.Commission / 100;
      this.setTotalValues();
    }
    this.formValidationCheck();

    if (isBlur) {
      this.onBlur();
    }
  }

  OnSave() {
    if (this.isSaveDisable) {
      this.notificationService.error("Validation error");
    } else {
      this.onSave.emit(this.paymentGenerateData);
      this.onCloseModal();
    }
  }

  formValidationCheck() {
    this.errorList = [];
    if (this.paymentGenerateData.filter(i => i.Commission != this.paymentData.Commission).length > 0) {
      this.errorList.push("The selected Commission differs from <b>the original Commission</b>. Are you sure you would like to continue.");
    }
    if (this.paymentGenerateData.filter(i => i.DueDate < this.paymentData.StartDate).length > 0) {
      this.errorList.push("The selected Date is before the <b>original Start Date</b>. Are you sure you would like to continue.");
    }
    if (this.totalGrossAmount != this.paymentData.TotalPaymentAmount) {
      this.errorList.push("The original <b>Total Amount was " + this.currencyName + "&nbsp;" + this.totalGrossAmount.toFixed(2) + "</b>. Are you sure you would like to continue.");
    }

    // Disable save when form not validated
    var check = this.paymentGenerateData.filter(i => i.GrossAmount <= 0 || i.GrossAmount == null || i.Commission == null || i.Commission < 0 || i.Commission > 100);

    this.isSaveDisable = check.length > 0 ? true : false;
  }

  checkDate(date: Date, addOnValue: number): Date {
    var dateCheck = new Date(date);

    if (this.dateAddonValue) {
      dateCheck.setDate(dateCheck.getDate() + addOnValue);
    } else {
      var monthDifference: number = 0

      var newDate = new Date(dateCheck.setMonth(dateCheck.getMonth() + addOnValue));

      if (addOnValue != 0) {
        monthDifference = (newDate.getFullYear() - date.getFullYear()) * 12 + (newDate.getMonth() - date.getMonth());
      }
      if (monthDifference != addOnValue) {
        var previousMonthDate = new Date(newDate.setMonth(newDate.getMonth() - 1));

        dateCheck = new Date(previousMonthDate.getFullYear(), previousMonthDate.getMonth() + 1, 0);
      }
    }

    return dateCheck;
  }
}
